import { render, staticRenderFns } from "./PMStructureLinksModal.vue?vue&type=template&id=57f67098&"
import script from "./PMStructureLinksModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureLinksModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureLinksModal.vue?vue&type=style&index=0&id=57f67098&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports